import HttpClient from "./HttpClient";

export default class Action{
    constructor(action){
        const date = new Date(action.time.date);
        this.completed_action = action.completed_action
        this.comment = action.comment;
        this.position = action.position;
        this.order_name = action.order_name;
        this.time = date.toLocaleString('lt-LT', { timeZone: 'UTC' })
        this.user_name = action.user_name;
        this.work_center_id = action.work_center_id;
    }

    static async getOperationsHistory(page, onlyProblems){
        const client = new HttpClient();
        const response = await client.instance.get(`actions/operations?page=${page}&only_problems=${onlyProblems}`);
        const actions = [];
        for(const row of response.data.data){
            actions.push(new Action(row));
        }
        return { actions: actions, pages: response.data.pages };
    }

    static async getOperationsHistoryByOrder(filter, page, onlyProblems){
        const client = new HttpClient();
        const response = await client.instance.get(`actions/operations/orders`, {
            params: {
                filter: filter,
                page: page,
                only_problems: onlyProblems
            }
        });
        const actions = [];
        for(const row of response.data.data){
            actions.push(new Action(row));
        }
        return { actions: actions, pages: response.data.pages };
    }
}